(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-footer-2026"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE = '(max-width: 749px)';

    function init(root) {
      if (!root || root.dataset.footerReady) return;
      root.dataset.footerReady = 'true';

      var mq = window.matchMedia(MOBILE);
      var toggles = root.querySelectorAll('[data-footer-toggle]');

      function apply() {
        toggles.forEach(function (btn) {
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          if (!panel) return;
          if (mq.matches) {
            var open = btn.dataset.open === 'true';
            btn.removeAttribute('tabindex');
            btn.removeAttribute('aria-disabled');
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            panel.hidden = !open;
          } else {
            // Desktop: columns are always open, the heading is not a control
            btn.setAttribute('tabindex', '-1');
            btn.setAttribute('aria-disabled', 'true');
            btn.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
          }
        });
      }

      toggles.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!mq.matches) return;
          btn.dataset.open = btn.dataset.open === 'true' ? 'false' : 'true';
          apply();
        });
      });

      // Country store switcher: close on outside click or Escape
      var stores = root.querySelector('[data-footer-stores]');
      if (stores) {
        document.addEventListener('click', function (event) {
          if (!stores.contains(event.target)) stores.removeAttribute('open');
        });
        stores.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && stores.hasAttribute('open')) {
            stores.removeAttribute('open');
            stores.querySelector('summary').focus();
          }
        });
      }

      if (mq.addEventListener) {
        mq.addEventListener('change', apply);
      } else if (mq.addListener) {
        mq.addListener(apply);
      }
      apply();
    }

    function initAll() {
      document.querySelectorAll('[data-paladin-footer]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Theme editor: re-run when the section is added or re-rendered
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target.querySelector('[data-paladin-footer]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE = '(max-width: 749px)';

    function init(root) {
      if (!root || root.dataset.footerReady) return;
      root.dataset.footerReady = 'true';

      var mq = window.matchMedia(MOBILE);
      var toggles = root.querySelectorAll('[data-footer-toggle]');

      function apply() {
        toggles.forEach(function (btn) {
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          if (!panel) return;
          if (mq.matches) {
            var open = btn.dataset.open === 'true';
            btn.removeAttribute('tabindex');
            btn.removeAttribute('aria-disabled');
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            panel.hidden = !open;
          } else {
            // Desktop: columns are always open, the heading is not a control
            btn.setAttribute('tabindex', '-1');
            btn.setAttribute('aria-disabled', 'true');
            btn.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
          }
        });
      }

      toggles.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!mq.matches) return;
          btn.dataset.open = btn.dataset.open === 'true' ? 'false' : 'true';
          apply();
        });
      });

      // Country store switcher: close on outside click or Escape
      var stores = root.querySelector('[data-footer-stores]');
      if (stores) {
        document.addEventListener('click', function (event) {
          if (!stores.contains(event.target)) stores.removeAttribute('open');
        });
        stores.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && stores.hasAttribute('open')) {
            stores.removeAttribute('open');
            stores.querySelector('summary').focus();
          }
        });
      }

      if (mq.addEventListener) {
        mq.addEventListener('change', apply);
      } else if (mq.addListener) {
        mq.addListener(apply);
      }
      apply();
    }

    function initAll() {
      document.querySelectorAll('[data-paladin-footer]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Theme editor: re-run when the section is added or re-rendered
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target.querySelector('[data-paladin-footer]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
